import { dataBookBookmark } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBookBookmark = /*#__PURE__*/createIcon(dataBookBookmark)
export default IconBookBookmark
